import React, { useEffect, useState } from 'react';
import CalendarDisconnectedAlert from '.././CalendarDisconnectedAlert';
import CalendarMissingPermissionsAlert from '.././CalendarMissingPermissionsAlert';
import { UserNotificationService } from '../../../services/v1/UserNotificationService';
import {
  UserNotification,
  UserNotificationCategory,
} from '../../../entities/v1/UserNotification';

function UserNotificationAlert(props: {
  userNotification?: UserNotification;
  handleClose: () => void;
}) {
  if (!props.userNotification) {
    return null;
  }

  switch (props.userNotification.category) {
    case UserNotificationCategory.CalendarDisconnected:
      return <CalendarDisconnectedAlert handleClose={props.handleClose} />;
    case UserNotificationCategory.CalendarMissingPermissions:
      return (
        <CalendarMissingPermissionsAlert handleClose={props.handleClose} />
      );
  }
}

export default function UserNotificationsWrapper() {
  const [wrapperActive, setWrapperActive] = useState(true);

  const [userNotification, setUserNotification] =
    useState<UserNotification>(null);

  const handleClose = async () => {
    try {
      await UserNotificationService.dismiss(userNotification.id);
    } catch (error) {
      console.error('Failed to update notification status:', error);
    } finally {
      setWrapperActive(false);
    }
  };

  useEffect(() => {
    UserNotificationService.get().then(setUserNotification);
  }, []);

  return (
    wrapperActive && (
      <UserNotificationAlert
        userNotification={userNotification}
        handleClose={handleClose}
      />
    )
  );
}
